module.exports = __webpack_public_path__ + "img/Westlife .feat DianaRoss.0cbb0f09.jpg";